#version 300 es
precision mediump float;
uniform sampler2D uScene;
in vec2 vUV;
out vec4 fragColor;

// Luminance-based soft threshold with a knee for smooth rolloff.
const float THRESHOLD = 0.72;
const float KNEE = 0.12;

void main() {
  vec3 color = texture(uScene, vUV).rgb;
  float lum = dot(color, vec3(0.2126, 0.7152, 0.0722));
  float knee_min = THRESHOLD - KNEE;
  float rq = clamp(lum - knee_min, 0.0, 2.0 * KNEE);
  rq = (rq * rq) / (4.0 * KNEE + 1e-5);
  float weight = max(rq, lum - THRESHOLD) / max(lum, 1e-4);
  fragColor = vec4(color * weight, 1.0);
}
